export default "__VITE_ASSET__muXh0aOz__"